import { get } from 'lodash';

const root = state => get(state, 'UtilitiesState.zeroNegativeBalance');
export const SaveSuccessful = state => get(root(state), 'saveSuccessful');
export const getLoading = state => get(root(state), 'loading');
export const getError = state => get(root(state), 'error');
export const getNegativesAccounts = state =>
  get(root(state), 'negativeAccounts');
export const getShowDialog = state => get(root(state), 'showDialog');
export const getShowNoDataDialog = state =>
  get(root(state), 'showNoDataDialog');



// WEBPACK FOOTER //
// ./src/pages/utilities/state/zeroNegativeBalance/selectors.js